import {
  GET_ARIZONADATA,
  GET_ARIZONADATA_FEB_2021,
  GET_ARIZONADATA_JAN_2021,
  GET_ARIZONADATA_DEC_2020,
  GET_ARIZONADATA_NOV_2020,
  GET_ARIZONADATA_OCT_2020,
  GET_ARIZONADATA_SEP_2020,
  GET_ARIZONADATA_AGO_2020,
  GET_ARIZONADATA_JUL_2020,
  GET_ARIZONADATA_JUN_2020,
  GET_ARIZONADATA_MAY_2020,
  GET_ARIZONADATA_APR_2020,
  GET_ARIZONADATA_MAR_2020,
  GET_ARIZONADATA_AGO_2021,
  GET_ARIZONADATA_APR_2021,
  GET_ARIZONADATA_DEC_2021,
  GET_ARIZONADATA_JUL_2021,
  GET_ARIZONADATA_JUN_2021,
  GET_ARIZONADATA_MAR_2021,
  GET_ARIZONADATA_MAY_2021,
  GET_ARIZONADATA_NOV_2021,
  GET_ARIZONADATA_OCT_2021,
  GET_ARIZONADATA_SEP_2021,
} from "./types";
import api from "../utils/api";

export const getArizonaData = (select) => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?sort=date.year,date.month,date.day${select}`
    );
    dispatch({
      type: GET_ARIZONADATA,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataDec2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=12&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_DEC_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataNov2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=11&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_NOV_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataOct2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=10&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_OCT_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataSep2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=9&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_SEP_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataAgo2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=8&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_AGO_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataJul2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=7&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_JUL_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataJun2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=6&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_JUN_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataMay2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=5&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_MAY_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataApr2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=4&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_APR_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataMar2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=3&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_MAR_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataFeb2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=2&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_FEB_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataJan2021 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2021&date.month=1&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_JAN_2021,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataDec2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=12&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_DEC_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataNov2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=11&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_NOV_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataOct2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=10&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_OCT_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataSep2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=9&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_SEP_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataAgo2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=8&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_AGO_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataJul2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=7&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_JUL_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataJun2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=6&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_JUN_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataMay2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=5&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_MAY_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataApr2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=4&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_APR_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
export const getArizonaDataMar2020 = () => async (dispatch) => {
  try {
    const res = await api.get(
      `arizonadatas?date.year=2020&date.month=3&sort=date.day`
    );
    dispatch({
      type: GET_ARIZONADATA_MAR_2020,
      payload: res.data.data,
    });
  } catch (error) {
    console.log(error);
  }
};
